/**
 * PdfCacheCollection.ts class for EJ2-PDF
 */
import { Dictionary } from './../collections/dictionary';
/**
 * `Collection of the cached objects`.
 * @private
 */
var PdfCacheCollection = /** @class */ (function () {
    // Constructors
    /**
     * Initializes a new instance of the `PdfCacheCollection` class.
     * @private
     */
    function PdfCacheCollection() {
        this.referenceObjects = [];
        this.pdfFontCollection = new Dictionary();
    }
    // Public methods
    /**
     * `Searches` for the similar cached object. If is not found - adds the object to the cache.
     * @private
     */
    PdfCacheCollection.prototype.search = function (obj) {
        var result = null;
        var group = this.createNewGroup();
        group.push(obj);
        return result;
    };
    // Implementation
    /**
     * `Creates` a new group.
     * @private
     */
    PdfCacheCollection.prototype.createNewGroup = function () {
        var group = [];
        this.referenceObjects.push(group);
        return group;
    };
    PdfCacheCollection.prototype.destroy = function () {
        this.pdfFontCollection = undefined;
        this.referenceObjects = undefined;
    };
    return PdfCacheCollection;
}());
export { PdfCacheCollection };
